import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";


export default function CertificationImageIcon (props: any) {

  const { style, width, height, ...otherProps } = props;

  return (
    <SvgIcon
      {...otherProps}
      style={{ width: width ?? 25, height: height ?? 25 }}
      viewBox="0 0 25 25"
    >
      <path
        d="M18.8599 19.5547C19.6724 19.5547 20.3599 18.7891 20.3599 17.8047V7.30469C20.3599 6.35677 19.6724 5.55469 18.8599 5.55469H5.85986C5.01611 5.55469 4.35986 6.35677 4.35986 7.30469V17.8047C4.35986 18.7891 5.01611 19.5547 5.85986 19.5547H18.8599ZM7.85986 7.59635C8.79736 7.59635 9.60986 8.54427 9.60986 9.63802C9.60986 10.7682 8.79736 11.6797 7.85986 11.6797C6.89111 11.6797 6.10986 10.7682 6.10986 9.63802C6.10986 8.54427 6.89111 7.59635 7.85986 7.59635ZM6.35986 17.2214V15.4714L8.57861 12.8828C8.73486 12.7005 8.95361 12.7005 9.10986 12.8828L10.8599 14.888L15.0786 9.96615C15.2349 9.78385 15.4536 9.78385 15.6099 9.96615L18.3599 13.138V17.2214H6.35986Z"
        fill="#6462F3"
      />
    </SvgIcon>
  )
};